"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.ConfiguratorLargeSummary = void 0;
var _configuratorLargeSummary = _interopRequireDefault(require("./components/configurator-large-summary"));
exports.ConfiguratorLargeSummary = _configuratorLargeSummary["default"];